// extracted by mini-css-extract-plugin
module.exports = {"modalShipmentCourier":"ShipmentCourierSelector_modalShipmentCourier__2mw1G","modalCourierContainer":"ShipmentCourierSelector_modalCourierContainer__mKOE8"};